var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TermosDeUsoComponent',{staticStyle:{"max-width":"1100px","margin":"0 auto"},attrs:{"id-termo":_vm.idTermo,"buttonsFooter":true},on:{"voltar":function($event){return _vm.$router.go(-1)},"aceito":_vm.proximo,"cancelar":_vm.voltar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }